export class CatalogConstants {
    public static readonly CATALOG = 'catalog';

    public static readonly CHECKBOX_FIELDS = {
        APPLICABLE_PACKAGE: 'applicablePackage' as const,
        SERVICE_MATRIX: 'serviceMatrix' as const,
        ROOM_SUMMARY: 'roomSummary' as const,
        REVIT_MODELS: 'revitModels' as const,
        ASSOCIATED_DOCUMENTS: 'associatedDocuments' as const,
        APPLICABLE_STANDARDS: 'applicableStandards' as const
    }
}